import type { AccountLocations } from './account';
import AccountLocationsImpl from './accountImpl';

export type { AccountLocations };
export default AccountLocationsImpl;
